import styled from '@emotion/styled';
import colors, { primaryBGNightBlack, white } from '../../../theme/colors';
import breakpoints from '../../../theme/material/breakpoints';
import { getBorders, getColor, getTextColor } from '../../../style';
import { isDarkMode } from '../../../utils/helpers';
import { CustomStyledProps } from 'style/style';
import { FONT_FAMILIES } from 'theme/material/constants';

export const PriceContainer = styled('div')<{ hasErrors: boolean }>(
  // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
  () => ({
    background: !isDarkMode() ? white : primaryBGNightBlack,
    textAlign: 'center',
    width: '100%',
    margin: '20px auto 10px auto',
    borderRadius: 4,
    boxShadow: isDarkMode() ? 'none' : '2px 2px 4px 0px rgba(0, 0, 0, 0.18) inset',
    fontFamily: FONT_FAMILIES.secondary,
    [breakpoints.down(768.05)]: {
      boxShadow: isDarkMode() ? 'none' : '2px 1px 3px 0px rgba(0, 0, 0, 0.18) inset',
    },
  }),
  ({ hasErrors }: CustomStyledProps) => ({
    border: hasErrors ? `2px solid ${colors.light.warning.primary}` : isDarkMode() ? 'none' : getBorders().PRIMARY,
  })
);

export const getInputProps = (): any => ({
  style: {
    fontWeight: 600,
    outline: 'none',
    border: 'none',
    color: !isDarkMode() ? colors.light.blue.secondary : colors.blue[200],
    errorColor: !isDarkMode() ? colors.light.blue.secondary : colors.blue[200],
  },
});

export const setColor = {
  default: {
    color: 'grey',
  },
  brand: {
    color: getColor().BRAND_1,
  },
  alert: { ...getTextColor().RED },
};

export const CurrencyTip = styled('div')(
  {
    display: 'inline-block',
    position: 'relative',
    fontFamily: FONT_FAMILIES.secondary,
  },
  ({ offerPrice }: CustomStyledProps) => ({
    ...setColor[offerPrice],
    ':before': {
      position: 'absolute',
      top: 14,
      right: '85%',
      fontSize: 22,
    },
  })
);

export const CurrencyLabelSpan = styled('span')(
  () => ({
    fontSize: 56,
    height: 72,
    fontWeight: 600,
    color: !isDarkMode() ? colors.light.blue.secondary : colors.blue[200],
    marginRight: -5,
    fontFamily: FONT_FAMILIES.secondary,
    [breakpoints.down('sm')]: {
      fontSize: 42,
      lineHeight: '42px',
      height: 56,
    },
  }),
  ({ customCurrencyLabelStyle }: CustomStyledProps) => ({ ...customCurrencyLabelStyle })
);

export const status = (currentUserIsGenerous: boolean): string => (currentUserIsGenerous ? 'Offer' : 'Offer Request');
